
// components/ProtectedRoute.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const user = useSelector((s) => s.user);
  const access = useSelector((s) => s.access);
  const location = useLocation();

  const isLoggedIn = !!user?.id;
  const plan = access?.subscriptionPlan || 'none';
  const loaded = access?.loaded;
  const isVerified = access?.isVerified === true;

   // 1) Wait until /auth/access has loaded
  if (!loaded) {
    return null; // or a loader/spinner component
  }

  // 2) Not logged in → send to landing
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

 

  const pathname = location.pathname;
  const isSubscribeRoute = pathname === '/subscribe';
  const isVerifyRoute = pathname === '/verify';

  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get('mode');

  // 3) If NOT verified:
  //    - any route except /verify → send to /verify
  //    - /verify itself → allow through, don't apply plan logic
  if (!isVerified) {
    if (!isVerifyRoute) {
      return <Navigate to="/verify" replace />;
    }
    return children;
  }

  // Optional: already verified but still on /verify → push them forward
  if (isVerified && isVerifyRoute) {
    if (plan === 'none') {
      return <Navigate to="/subscribe" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // 4) ACTIVE: never show subscribe page
  if (plan === 'Active' && isSubscribeRoute) {
    return <Navigate to="/dashboard" replace />;
  }

  // 5) NONE: must go to /subscribe (first-time / cancelled)
  if (plan === 'none' && !isSubscribeRoute) {
    return <Navigate to="/subscribe" replace />;
  }

  // If plan === 'none' AND on /subscribe → allowed

  // 6) PAST DUE: can access everything (grace), but subscribe must be mode=change
  if (plan === 'PastDue' && isSubscribeRoute && mode !== 'change') {
    return <Navigate to="/subscribe?mode=change" replace />;
  }

  // For PastDue:
  // - /search, /dashboard, etc. → allowed
  // - /subscribe?mode=change → allowed

  return children;
};

export default ProtectedRoute;